import { render, staticRenderFns } from "./TransportForm.vue?vue&type=template&id=5f4f26ba&scoped=true"
import script from "./TransportForm.vue?vue&type=script&lang=js"
export * from "./TransportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f26ba",
  null
  
)

export default component.exports